export class Information {
  public id: number;
  public title: string;
  public question: string;
  public response: string;
  public isActive: boolean;
  public isLinked: boolean;
  public showHomePage: boolean;
  public lastChange: string;

  constructor(
    id = NaN,
    title = "",
    question = "",
    response = "",
    isActive = true,
    showHomePage = true,
    isLinked = false,
    lastChange = ""
  ) {
    this.id = id;
    this.title = title;
    this.question = question;
    this.response = response;
    this.isActive = isActive;
    this.isLinked = isLinked;
    this.showHomePage = showHomePage;
    this.lastChange = lastChange;
  }
}
